import { mapState } from 'vuex'
import Calendar from '@/components/common/calendar/Calendar.vue';
import DigiDotPortalLink from '@/components/digidot/portallink/DigiDotPortalLink.vue';

export default {
  components: {
    Calendar,
    DigiDotPortalLink
  },
  computed: {
    ...mapState(['config', 'sessionReloaded']),
    sessionReloadCounter () {
      return this.sessionReloaded;
    },
    sessionSelectedClient () {
      return this.$session.get('selectedClientApiId');
    },
    menuItems () {
      if (this.config);
      if (this.$session.exists()) {
        let permissions = this.$session.get('permissions');
        if (typeof (permissions) !== 'object') {
          permissions = [];
        }
        return this.$router.options.routes.filter(el => {
          if (el.meta.hasClientOrManager && !(this.hasClient || permissions.includes('view-clients'))) {
            return false;
          }
          if (el.meta.isMenuItem &&
            (el.meta.permissions === null || el.meta.permissions.filter(Set.prototype.has, new Set(permissions)).length > 0)) {
            return true;
          }
          return false;
        });
      }
      return [];
    },
    submenu () {
      if (this.config);
      if (this.$session.exists()) {
        const parentEl = this.$route.meta.parentPath;
        if (typeof (parentEl) !== 'undefined') {
          let permissions = this.$session.get('permissions');
          if (typeof (permissions) !== 'object') {
            permissions = [];
          }
          const menuMatch = this.$router.options.routes.filter(el => {
            if (el.meta.isMenuItem && el.path === parentEl &&
              (el.meta.permissions === null || el.meta.permissions.filter(Set.prototype.has, new Set(permissions)).length > 0)) {
              return true;
            }
            return false;
          });
          if (menuMatch && menuMatch[0] && menuMatch[0].children) {
            const matches = menuMatch[0].children.filter(el => {
              if (el.meta && el.meta.isMenuItem &&
                (el.meta.permissions === null || el.meta.permissions.filter(Set.prototype.has, new Set(permissions)).length > 0)) {
                return true;
              }
              return false;
            });
            if (menuMatch[0].meta.hideChildrenIfOne && matches.length < 2) {
              return null;
            }
            return matches;
          }
        }
      }
      return null;
    },
    localelist () {
      if (this.config && this.config.locales && Object.keys(this.config.locales).length > 1) {
        return this.config.locales;
      }
      return null;
    },
    canViewAllClients () {
      if (this.ApiRequest.userHasPermission('view-clients')) {
        return true;
      }
      return false;
    },
    clientList () {
      if (this.sessionReloaded && this.sessionSelectedClient);
      return this.$session.get('client_permissions');
    },
    hasClient () {
      const clientPerm = this.$session.get('client_permissions');
      if (this.sessionReloaded && clientPerm && Object.values(clientPerm).length > 0) {
        return true;
      }
      return false;
    },
    clientIsBlocked () {
      if (this.sessionReloaded && this.sessionSelectedClient);
      return this.BasicHelper.isUserClientBlocked();
    },
    userClientName () {
      if (this.sessionReloaded && this.sessionSelectedClient);
      return this.BasicHelper.getUserClientName()
    }
  },
  methods: {
    logout () {
      const self = this;
      this.ApiRequest.request('logout', this.ApiRequest.REQUEST_POST, [], function (response) {
        self.$session.destroy();
        self.$router.push('/login');
      });
    },
    changeLocale (localeCode) {
      this.$root.$i18n.locale = localeCode;
      this.$cookie.set('locale', localeCode, { expires: '1Y' });
      this.$parent.$parent.$forceUpdate();
      if (this.$session.exists()) {
        this.$session.set('locale', localeCode);
        this.$parent.$parent.$forceUpdate();
        this.ApiRequest.request('user/change-locale', this.ApiRequest.REQUEST_POST, { locale: localeCode }, function () {})
      }
    },
    changeClient (clientApiId) {
      this.$session.set('selectedClientApiId', clientApiId);
      this.$store.dispatch('sessionUpdated');
      this.$router.go(this.$router.currentRoute);
    },
    openCalendar () {
      this.$refs.calendarmodal.show();
    },
    cancelSimulate () {
      const self = this;
      this.ApiRequest.request('user/loginas-cancel', this.ApiRequest.REQUEST_GET, { }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        } else {
          if (response.data && response.data.user) {
            self.$session.set('accessToken', self.$session.get('originalAccessToken'));
            self.$session.set('uuid', response.data.user.api_id);
            self.$session.set('user', response.data.user.name);
            self.$session.set('email', response.data.user.email);
            self.$session.set('locale', response.data.user.defaultLang);
            self.$session.set('permissions', response.data.user.permissions);
            self.$session.set('client_permissions', response.data.user.client_permissions);
            self.$session.set('roles', response.data.user.roles.map(a => a.name));
            self.$session.set('isSimUser', false);
            self.$session.set('originalAccessToken', '');
            self.$session.set('selectedClientApiId', '');
            self.$root.$i18n.locale = response.data.user.defaultLang;
            self.$store.dispatch('loadConfig');
            self.$store.dispatch('sessionUpdated');
            self.$router.push('/home');
          } else {
            self.$session.destroy()
            self.$router.push('/login')
          }
        }
      });
    }
  },
  mounted () {
    let curLocale = this.$cookie.get('locale');
    if (this.$route.query.lang) {
      curLocale = this.$route.query.lang;
    }
    if (curLocale && curLocale !== this.$i18n.locale) {
      this.changeLocale(curLocale);
    } else if (!curLocale) {
      this.$cookie.set('locale', this.$i18n.locale, { expires: '1Y' });
    }
  },
  watch: {
    sessionReloadCounter: {
      immediate: true,
      handler (val) {
        this.$forceUpdate();
      }
    },
    sessionSelectedClient: {
      immediate: true,
      handler (val) {
        this.$forceUpdate();
      }
    }
  }
}
